<template>
    <div id="modeler" v-loading="loading" :element-loading-text="loadingText">
        <div id="modeler-ribbon">
            <div id="modeler-ribbon-header">
                <span id="modeler-ribbon-title" style="color: var(--color)">
                    <!--<dh-icon :name="$icons.modelOpen" :style-svg="{transform: 'scale(1.5)'}"/>&nbsp;&nbsp;-->
                    {{ title }}
                </span>
                <MenuUserModel id="user-model-menu"/>
            </div>
            <div id="modeler-button-bar">
                <slot name="button-bar"/>
            </div>
        </div>
        <div id="modeler-body">
            <slot name="body"/>
        </div>
    </div>
</template>

<script>
  import MenuUserModel from "./ribbon/menu_user-model/MenuUserModel";
  export default {
    name: "ModelerBase",
    components: {MenuUserModel},
    props: {
      title: String,
      loading: {
        type: Boolean,
        default: false
      },
      loadingText: {
        type: String,
        default: 'Loading'
      },
    },
  }
</script>

<style scoped src="../assets/css/layout-modeler.css"/>
